import {
  IncidentProduct,
  IncidentSeverity,
  IncidentStatus,
} from "@redotech/redo-model/incidents/incident";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const createIncident = {
  name: "createIncident" as const,
  input: z.object({
    title: z.string().min(1),
    message: z.string().min(1),
    severity: createEnum(IncidentSeverity),
    status: createEnum(IncidentStatus),
    type: createEnum(IncidentProduct).optional(),
    types: z.array(createEnum(IncidentProduct)).optional(),
    isGlobal: z.boolean(),
    isTest: z.boolean(),
    adminOnly: z.boolean().optional(),
    routeScoped: z.boolean().optional(),
    teamIds: z.array(zExt.objectId()).optional(),
    notes: z.string().optional(),
    publicUrl: z.string().url().optional(),
  }),
  output: z.object({ incidentId: zExt.objectId() }),
};
